import { render, staticRenderFns } from "./commonQuestions.vue?vue&type=template&id=c345f802&scoped=true&"
import script from "./commonQuestions.vue?vue&type=script&lang=js&"
export * from "./commonQuestions.vue?vue&type=script&lang=js&"
import style0 from "./commonQuestions.vue?vue&type=style&index=0&id=c345f802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c345f802",
  null
  
)

export default component.exports